import React from 'react';
import PropTypes from 'prop-types';
import OralReadingContent from './OralReadingContent';
import './OralReadingProbeDetails.scss';

const OralReadingProbeDetails = ({ result, content: { title, paragraphs }, selfCorrectedMark }) => (
    <div className="container">
        <div className="dorf-redesign">
            <div className="row">
                <div className="col-10">
                    <div className="content-title">
                        <h2 className="title">{title}</h2>
                    </div>
                    <div className="content-text">
                        <OralReadingContent
                            itemLevelDetails={result.itemLevelDetails}
                            paragraphs={paragraphs}
                            selfCorrectedMark={selfCorrectedMark}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

OralReadingProbeDetails.defaultProps = {
    selfCorrectedMark: 'sc',
};

OralReadingProbeDetails.propTypes = {
    content: PropTypes.object.isRequired,
    result: PropTypes.object.isRequired,
    selfCorrectedMark: PropTypes.string,
};

export default OralReadingProbeDetails;
